import * as React from "react";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { GroupFragment, GroupKindEnum } from '../../graphql/generated/definitions';
import useTranslations from "../../hooks/useTranslations";
import { Input, Select, Textarea } from "../wombat-ui";

interface InsertGroupFormProps {
  group?: GroupFragment;
  defaultName?: string;
  submit;
}

export const InsertGroupForm: React.FC<InsertGroupFormProps> = ({
  group,
  submit,
  defaultName,
}) => {
  const t = useTranslations();
  const { handleSubmit, register, setValue, unregister } = useForm({
    defaultValues: {
      ...(group || {}),
    },
  });

  const groupsKinds = useMemo(
    (): {
      value: GroupKindEnum;
      label: string;
    }[] => [
      {
        value: "Other",
        label: t("groups.types.Other") as string,
      },
      {
        value: "Team",
        label: t("groups.types.Team") as string,
      },
      {
        value: "Partner",
        label: t("groups.types.Partner") as string,
      },
      {
        value: "Subsidiary",
        label: t("groups.types.Subsidiary") as string,
      },
      {
        value: "TrainingCourse",
        label: t("groups.types.TrainingCourse") as string,
      },
    ],
    []
  );

  React.useEffect(() => {
    if (defaultName) {
      setValue("name", defaultName);
    }
  }, [defaultName]);

  return (
    <form
      onSubmit={handleSubmit(submit)}
      id="insertGroupForm"
      className="flex flex-col gap-y-4"
    >
      <input type="hidden" name="id" ref={register()} />
      <Input
        id="name"
        className="w-full"
        label={t("groups.name") as string}
        name="name"
        ref={register()}
      />
      <Select
        id="group-type"
        label={t("groups.type") as string}
        items={groupsKinds}
        defaultValue={groupsKinds[0]}
        searchOption={{
          keys: ["label"],
          threshold: 0.2,
          useExtendedSearch: true,
        }}
        getValue={(i) => i.value}
        renderItem={(i) => i.label}
        searchable
        RHF={{ register, name: "kind", setValue, unregister }}
      />
      <div className="max-w-2xl">
        <Textarea
          id="description"
          rows={3}
          label={t("groups.description") as string}
          name="description"
          ref={register()}
        />
      </div>
    </form>
  );
};
